import React, {useState} from 'react';
import {Button, Col, FormControl, Row} from "react-bootstrap";

const OpenCheckboxShift = ({onOpenShift}) => {
  const [initialBalance, setInitialBalance] = useState('');

  const initialBalanceIsValid = () => {
        const integerInitialBalance = parseInt(initialBalance);
        return !Number.isNaN(integerInitialBalance) && integerInitialBalance >= 0;
    };

  return (
    <Row className='py-4'>
      <Col sm={3}>
        <FormControl
          type="number"
          placeholder="Службове внесення"
          value={initialBalance}
          onChange={e => setInitialBalance(e.target.value)}
        />
      </Col>
      <Col>
        <Button
          onClick={() => onOpenShift(initialBalance)}
          disabled={!initialBalanceIsValid()}
        >Відкрити</Button>
      </Col>
    </Row>
  )
}

export default OpenCheckboxShift;